import { Controller } from "@hotwired/stimulus"

// A saved attachment can outlive its file in storage. Show a useful action in
// the admin when the browser cannot load the preview.
export default class extends Controller {
  static targets = ["image", "fallback"]

  connect() {
    if (this.imageTarget.complete && this.imageTarget.naturalWidth === 0) this.failed()
  }

  failed() {
    this.imageTarget.hidden = true
    this.fallbackTarget.hidden = false
  }
}
